import React, { useState } from 'react';
import styles from '../furnishingContainer.module.scss';
import FurnishingPackageForm from '../FurnishingPackageForm';
import FurnishingPackageCards from '../FurnishingPackageCards';
import type { FurnishingPackage } from '../types';

interface PackagesTabContainerProps {
  packages: FurnishingPackage[];
  onPackagesChange: (packages: FurnishingPackage[]) => void;
  isLoading?: boolean;
}

export const PackagesTabContainer: React.FC<PackagesTabContainerProps> = ({
  packages,
  onPackagesChange
}) => {
  const [displayLanguage, setDisplayLanguage] = useState<'en' | 'ar'>('en');

  const handlePackageAdded = (newPackage: FurnishingPackage) => {
    onPackagesChange([newPackage, ...packages]);
  };

  const totalPackagesCopy = packages.length === 1 ? '1 package' : `${packages.length} packages`;

  return (
    <>
      {packages?.length < 4 && <FurnishingPackageForm onPackageAdded={handlePackageAdded} />}

      <div className={styles['furnishing-management__gallery-header']}>
        <h2>Package gallery</h2>
        <div className={styles['furnishing-management__language-toggle']}>
          <button
            type="button"
            className={`${styles['furnishing-management__language-button']} ${
              displayLanguage === 'en'
                ? styles['furnishing-management__language-button--active']
                : ''
            }`}
            onClick={() => setDisplayLanguage('en')}
          >
            EN
          </button>
          <button
            type="button"
            className={`${styles['furnishing-management__language-button']} ${
              displayLanguage === 'ar'
                ? styles['furnishing-management__language-button--active']
                : ''
            }`}
            onClick={() => setDisplayLanguage('ar')}
          >
            AR
          </button>
        </div>
        <span className={styles['furnishing-management__count']}>{totalPackagesCopy}</span>
      </div>

      <FurnishingPackageCards
        packages={packages}
        displayLanguage={displayLanguage}
        onPackagesChange={onPackagesChange}
      />
    </>
  );
};
